export default "__VITE_ASSET__$uglrQjx__"